module.exports = __webpack_public_path__ + "static/img/4.cc2f125.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store_files/images/colorpop/4.jpg
// module id = 85hr
// module chunks = 1